import { OffTargetVariant1Icon, OnTargetVariant1Icon } from '@/common/assets';
import type { ShotIndicatorProps } from './ShotsChart.types';

export function ShotIndicator(props: ShotIndicatorProps) {
  const { className = '', value, isOnTarget = false, isAway = false } = props;

  const colorClassName = isAway
    ? 'text-pmw-bar-orange-light dark:text-pmw-bar-orange-dark'
    : 'text-pmw-bar-blue-light dark:text-pmw-bar-blue-dark';

  const icon = isOnTarget ? (
    <OnTargetVariant1Icon className={colorClassName} />
  ) : (
    <OffTargetVariant1Icon className={colorClassName} />
  );

  return (
    <div className={`relative inline-block ${className}`}>
      <div className="absolute inset-0 flex items-center justify-center font-unibet text-[24px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
        {value}
      </div>
      {icon}
    </div>
  );
}
